<template>
  <el-dialog
    title="新增采收记录"
    :visible.sync="visible"
    width="1100px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="order-add-form">
      <el-form :model="form" :rules="rules" ref="orderForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="采收日期" prop="harvestDate" required>
              <el-date-picker
                v-model="form.harvestDate"
                type="date"
                placeholder="请选择采收日期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="基地/大棚" prop="greenhouseId" required>
              <el-select
                v-model="form.greenhouseId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="item in greenhouseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="草莓品种" prop="varietyId" required>
              <el-select
                v-model="form.varietyId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in varietyOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 8px">
          <el-col :span="8">
            <el-form-item label="采收负责人" prop="harvestManagerId" required>
              <el-select
                v-model="form.harvestManagerId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in harvestManagerOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="采收总量(kg)" prop="sumWeight">
              <el-input-number
                v-model="form.sumWeight"
                :min="0"
                :controls="false"
                :precision="3"
                style="width: 100%"
                :step="0.1"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="仓储位置" prop="basicStorageId">
              <el-select
                v-model="form.basicStorageId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in storageOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 8px">
          <el-col :span="24">
            <el-form-item label="采收图片" prop="attachment">
              <ImageUpload v-model="form.attachment" :maxCount="3" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit(false)">确定</el-button>
      <el-button type="primary" plain @click="submit(true)">暂存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import ImageUpload from "@/components/ImageUpload.vue";
import dayjs from "dayjs";
import { mapState } from "vuex";
export default {
  name: "OrderAddDialog",
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    greenhouseOptions: {
      type: Array,
      default: () => [],
    },
    harvestManagerOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        isDraft: false,
        harvestDate: null,
        greenhouseId: "",
        varietyId: "",
        harvestManagerId: "",
        sumWeight: null,
        basicStorageId: "",
        attachment: [],
      },
      varietyOptions: [],
      storageOptions: [],
      rules: {
        harvestDate: [
          { required: true, message: "请选择采收日期", trigger: "change" },
        ],
        greenhouseId: [
          { required: true, message: "请选择大棚", trigger: "change" },
        ],
        varietyId: [
          { required: true, message: "请选择草莓品种", trigger: "change" },
        ],
        harvestManagerId: [
          { required: true, message: "请选择采收负责人", trigger: "change" },
        ],
        sumWeight: [
          { required: true, message: "请输入采收重量", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchVarietyOptions();
        this.fetchStorageOptions();
        this.form.harvestManagerId = this.userInfo.userId;
      } else {
        // reset form when closed
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        isDraft: false,
        harvestDate: null,
        greenhouseId: "",
        varietyId: "",
        harvestManagerId: "",
        sumWeight: null,
        basicStorageId: "",
        attachment: [],
      };
      if (this.$refs.orderForm) {
        this.$refs.orderForm.clearValidate();
      }
    },
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/strawberry-variety/selection"
        );
        console.log("草莓品种", res);

        if (res && res.code === 200) {
          this.varietyOptions = res.data.map((it) => ({
            label: it.varietyName,
            value: it.id,
          }));
        }
      } catch (e) {
        console.error("fetchVarietyOptions error:", e);
      }
    },
    async fetchStorageOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/storage-location/selection",
          { enableStatus: true }
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.storageOptions = res.data.map((it) => ({
            label: it.storageName,
            value: it.id,
          }));
        }
      } catch (e) {
        console.error("fetchStorageOptions error:", e);
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    async submit(isDraft) {
      this.form.isDraft = !!isDraft;
      // validate required fields
      this.$refs.orderForm.validate(async (valid) => {
        if (!valid) return;

        // 获取对应的名称
        const selectedGreenhouse = this.greenhouseOptions.find(
          (item) => item.value === this.form.greenhouseId
        );
        const selectedHarvestManager = this.harvestManagerOptions.find(
          (item) => item.value === this.form.harvestManagerId
        );
        const selectedVariety = this.varietyOptions.find(
          (item) => item.value === this.form.varietyId
        );
        const selectedStorage = this.storageOptions.find(
          (item) => item.value === this.form.basicStorageId
        );

        const payload = {
          isDraft: this.form.isDraft,
          harvestDate: dayjs(this.form.harvestDate).format("YYYY-MM-DD"),
          greenhouseId: this.form.greenhouseId,
          greenhouseName: selectedGreenhouse ? selectedGreenhouse.label : "",
          varietyId: this.form.varietyId,
          varietyName: selectedVariety ? selectedVariety.label : "",
          harvestManagerId: this.form.harvestManagerId,
          harvestManager: selectedHarvestManager
            ? selectedHarvestManager.label
            : "",
          sumWeight: this.form.sumWeight,
          basicStorageId: this.form.basicStorageId,
          basicStorageName: selectedStorage ? selectedStorage.label : "",
          attachment: Array.isArray(this.form.attachment)
            ? this.form.attachment
            : [],
        };

        try {
          const res = await axios.post(
            baseUrl + "/api/digital-farming/harvest/add-order",
            payload
          );
          if (res && res.code === 200) {
            this.$message &&
              this.$message.success &&
              this.$message.success("提交成功");
            this.$emit("success");
            this.handleClose();
          } else {
            this.$message &&
              this.$message.error &&
              this.$message.error(
                res && res.message ? res.message : "提交失败"
              );
          }
        } catch (err) {
          console.error("add-order error:", err);
          this.$message &&
            this.$message.error &&
            this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.order-add-form {
  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>
